import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "asVideoConsultations" }
const _hoisted_2 = { class: "asVideoConsultations_title_wrapper" }
const _hoisted_3 = { class: "asVideoConsultations_title" }
const _hoisted_4 = { class: "asVideoConsultations_empty" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "asVideoConsultations_empty_icon" }, null, -1)
const _hoisted_6 = { class: "asVideoConsultations_empty" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "asVideoConsultations_empty_icon" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_tabs = _resolveComponent("as-tabs")!
  const _component_mq_responsive = _resolveComponent("mq-responsive")!
  const _component_as_video_consultations_cards = _resolveComponent("as-video-consultations-cards")!
  const _component_as_container = _resolveComponent("as-container")!
  const _component_as_banners_catalog = _resolveComponent("as-banners-catalog")!
  const _component_as_preloader = _resolveComponent("as-preloader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_as_container, { class: "asVideoConsultations_container" }, {
            content: _withCtx(() => [
              _createVNode(_component_mq_responsive, { target: "mobile-tablet" }, {
                default: _withCtx(() => [
                  _createVNode(_component_as_tabs, {
                    class: "asVideoConsultations_tabs",
                    tabs: _ctx.mobileTabs,
                    current: _ctx.currentTab,
                    grow: "",
                    onSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentTab($event)))
                  }, null, 8, ["tabs", "current"])
                ]),
                _: 1
              }),
              _createVNode(_component_mq_responsive, { target: "desktop" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
                    _createVNode(_component_as_tabs, {
                      class: "asVideoConsultations_tabs",
                      tabs: _ctx.mobileTabs,
                      current: _ctx.currentTab,
                      onSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCurrentTab($event)))
                    }, null, 8, ["tabs", "current"])
                  ])
                ]),
                _: 1
              }),
              (_ctx.currentTab === 'available')
                ? (_openBlock(), _createBlock(_component_as_video_consultations_cards, {
                    key: 0,
                    videoConsultations: _ctx.availableConsultations
                  }, {
                    empty: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('videoConsultations.emptyAvailable')), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["videoConsultations"]))
                : _createCommentVNode("", true),
              (_ctx.currentTab === 'history')
                ? (_openBlock(), _createBlock(_component_as_video_consultations_cards, {
                    key: 1,
                    videoConsultations: _ctx.archiveConsultations,
                    type: "history"
                  }, {
                    empty: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('videoConsultations.emptyHistory')), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["videoConsultations"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_mq_responsive, {
            target: "mobile-tablet",
            slim: ""
          }, {
            default: _withCtx(() => [
              (_ctx.loaded)
                ? (_openBlock(), _createBlock(_component_as_banners_catalog, {
                    key: 0,
                    banners: _ctx.bannersCatalog,
                    position: _ctx.bannersPosition
                  }, null, 8, ["banners", "position"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 64))
      : (_openBlock(), _createBlock(_component_as_preloader, { key: 1 }))
  ]))
}